import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { GroupInsertDto } from '../../dtos/groupInsertDto';
import { GroupUpdateDto } from '../../dtos/groupUpdateDto';
import { GroupResponseDto } from '../../dtos/groupResponseDto';
import { Observable, map } from 'rxjs';
import { Pagination } from '../../models/pagination';

@Injectable({ providedIn: 'root' })
export class NewGroupHttpService {

    constructor(private httpClient: HttpClient) { }

    public insert(object: GroupInsertDto): Observable<GroupResponseDto> {
        return this.httpClient.post<GroupResponseDto>('/groups', object);
    }

    public update(id: number | string, object: GroupUpdateDto): Observable<GroupResponseDto> {
        return this.httpClient.put<GroupResponseDto>(`/groups/${id}`, object);
    }

    public delete(id: number | string): Observable<any> {
        return this.httpClient.delete<any>(`/groups/${id}`);
    }

    public findById(id: number | string): Observable<GroupResponseDto> {
        return this.httpClient.get<GroupResponseDto>(`/groups/${id}`);
    }

    public findAllWithFilters(finalFilters: string, sortBy?: string, direction?: string): Observable<GroupResponseDto[]> {
        const req = this.parseFilterString(finalFilters, 0, 1000, sortBy, direction);
        return this.httpClient.post<Pagination<GroupResponseDto>>('/groups/queries', req).pipe(
            map(res => {
                res.content?.forEach(g => this.filterUnresolvedAgents(g));
                return res.content;
            })
        );
    }

    public findAllWithPagesAndFilters(finalFilters: string, page: number, size: number, sortBy?: string, direction?: string): Observable<Pagination<GroupResponseDto>> {
        const req = this.parseFilterString(finalFilters, page, size, sortBy, direction);
        return this.httpClient.post<any>('/groups/queries', req).pipe(
            map(res => {
                const result = {
                    content: res.content,
                    page: {
                        size: res.size,
                        number: res.number,
                        totalElements: res.totalElements,
                        totalPages: res.totalPages
                    }
                };
                result.content?.forEach((g: GroupResponseDto) => this.filterUnresolvedAgents(g));
                return result;
            })
        );
    }

    private parseFilterString(filters: string, page: number, size: number, sortBy?: string, direction?: string): any {
        const req: any = { page, size, sortBy, direction: direction?.toUpperCase() || 'ASC' };
        if (!filters) return req;

        const parts = filters.split(';');
        parts.forEach(part => {
            if (part.includes('!=NOGROUP') && part.startsWith('name')) {
                req.nameNotEquals = 'NOGROUP';
            } else if (part.includes('=re=')) {
                let val = part.split('=re=')[1];
                if (val.startsWith('"') && val.endsWith('"')) {
                    val = val.substring(1, val.length - 1);
                }
                req.nameContains = val;
            } else if (part.startsWith('type==')) {
                req.type = part.split('==')[1];
            } else if (part.startsWith('assignedAgentIds==')) {
                const idsStr = part.split('==')[1];
                req.assignedAgentIds = req.assignedAgentIds || [];
                req.assignedAgentIds.push(idsStr);
            } else if (part.startsWith('assignedPrincipalIds==')) {
                const idsStr = part.split('==')[1];
                req.assignedPrincipalIds = req.assignedPrincipalIds || [];
                req.assignedPrincipalIds.push(idsStr);
            }
        });
        return req;
    }

    private filterUnresolvedAgents(group: GroupResponseDto) {
        if (group.assignedAgentIds && group.assignedAgentNames && group.assignedAgentIds.length === group.assignedAgentNames.length) {
            const validIds: string[] = [];
            const validNames: string[] = [];
            for (let i = 0; i < group.assignedAgentIds.length; i++) {
                const id = group.assignedAgentIds[i];
                const name = group.assignedAgentNames[i];
                if (id !== name) {
                    validIds.push(id);
                    validNames.push(name);
                }
            }
            group.assignedAgentIds = validIds;
            group.assignedAgentNames = validNames;
        }
    }
}
